export default "__VITE_ASSET__BFU_xkll__"